import React from "react";
import { useTranslation } from "react-i18next";
import { Icons } from "assets/icons";



const TierMovement = ({upgrades ,downgrades ,dataUnit}) => {
  const { t } = useTranslation();
  // const { upgrades, downgrades } = TIER_MOVEMENT_DATA || {};
  const { upgrade, downgrade } = Icons || {};

  return (
    <div className="tier_movement sentiment_card dashboard_common_card">
      <h3 className="fs_20">{t("Tier Movement")}</h3>

      {/* Upgrades */}
      <div className="tier_item">
        <div className="tier_icon up">
          <img src={upgrade} alt="up" />
        </div>

        <div className="tier_content">
          <div className="tier_header">
            <span>{t("Upgrades")}</span>
            <span>
              <strong>{upgrades}</strong> <small>{`${t("Last")} ${dataUnit?.value} ${dataUnit?.unit}`}</small>
            </span>
          </div>

          <div className="sentiment_bar">
            <span
              className="sentiment_bar__fill"
              style={{
                "--target-width": `${upgrades?.percent}%`,
                background: "#63D376",
              }}
            />
          </div>
        </div>
      </div>

      {/* Downgrades */}
      <div className="tier_item">
        <div className="tier_icon down">
          <img src={downgrade} alt="down" />
        </div>

        <div className="tier_content">
          <div className="tier_header">
            <span>{t("Downgrades")}</span>
            <span>
              <strong>{downgrades}</strong> <small>{`${t("Last")} ${dataUnit?.value} ${dataUnit?.unit}`}</small>
            </span>
          </div>

          <div className="sentiment_bar">
            <span
              className="sentiment_bar__fill"
              style={{
                "--target-width": `${downgrades?.percent}%`,
                background: "#FF4D4F",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TierMovement;
